import { registerContentType } from './registry';
import { ContentRenderer } from './ContentRenderer';
import { ContentEditor } from './ContentEditor';
import { BlogPostRenderer } from './BlogPostRenderer';
import { SocialPostRenderer } from './SocialPostRenderer';
import { LandingPageRenderer } from './LandingPageRenderer';
import { AdGroupRenderer } from './AdGroupRenderer';
import { ContentTypeConfig } from './types';

// Import editors
import BlogPostEditor from './BlogPostEditor';
import SocialPostEditor from './SocialPostEditor';
import LandingPageEditor from './LandingPageEditor';
import AdGroupEditor from './AdGroupEditor';

// Register all available content types
const contentTypes: ContentTypeConfig[] = [
    {
        id: 'blog_post',
        displayName: 'Blog Post',
        description: 'A blog post with title, body, and optional media',
        renderer: BlogPostRenderer,
        editor: BlogPostEditor
    },
    {
        id: 'social_post',
        displayName: 'Social Post',
        description: 'A social media post for platforms like Twitter, Facebook, etc.',
        renderer: SocialPostRenderer,
        editor: SocialPostEditor
    },
    {
        id: 'landing_page',
        displayName: 'Landing Page',
        description: 'A landing page with configurable sections',
        renderer: LandingPageRenderer,
        editor: LandingPageEditor
    },
    {
        id: 'ad_group',
        displayName: 'Ad Group',
        description: 'A collection of ads for Google, Facebook, or LinkedIn campaigns',
        renderer: AdGroupRenderer,
        editor: AdGroupEditor
    }
    // Add more content types here as they're created
];

// Register all content types
contentTypes.forEach(contentType => {
    registerContentType(contentType);
});

// Export the main renderer component
export { ContentRenderer, ContentEditor };

// Export registry for access from other components
export * from './types';
export * from './registry';

// Export default ContentRenderer component
export default ContentRenderer; 